import Icon from '@material-ui/icons/EventAvailable';
export default Icon;